import React, { useState, useEffect } from 'react'
import { Box, TextField, Button, Typography } from '@mui/material'
import ContentPasteIcon from '@mui/icons-material/ContentPaste'
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft'

/**
 * Componente para pegar GeoJSON como texto
 */
const TextPaster = ({ value, onChange }) => {
    const [localValue, setLocalValue] = useState(value || '')

    useEffect(() => {
        setLocalValue(value || '')
    }, [value])

    const handleChange = (e) => {
        const newValue = e.target.value
        setLocalValue(newValue)
        // Debounce: solo validar cuando deja de escribir
    }

    const handleBlur = () => {
        if (localValue.trim()) {
            onChange(localValue)
        } else {
            onChange('')
        }
    }

    const handlePaste = async () => {
        try {
            const text = await navigator.clipboard.readText()
            setLocalValue(text)
            onChange(text)
        } catch (err) {
            console.error('Error al pegar:', err)
        }
    }

    const handleFormat = () => {
        try {
            const parsed = JSON.parse(localValue)
            const formatted = JSON.stringify(parsed, null, 2)
            setLocalValue(formatted)
            onChange(formatted)
        } catch {
            // Si no es JSON válido, no hacer nada
        }
    }

    return (
        <Box>
            <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={<ContentPasteIcon />}
                    onClick={handlePaste}
                >
                    Pegar del portapapeles
                </Button>
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={<FormatAlignLeftIcon />}
                    onClick={handleFormat}
                    disabled={!localValue}
                >
                    Formatear JSON
                </Button>
            </Box>

            <TextField
                multiline
                rows={12}
                fullWidth
                value={localValue}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={`Pegue aquí su GeoJSON, por ejemplo:

{
  "type": "Feature",
  "geometry": {
    "type": "Polygon",
    "coordinates": [[[lng, lat], ...]]
  },
  "properties": {}
}`}
                sx={{
                    '& .MuiInputBase-root': {
                        fontFamily: 'monospace',
                        fontSize: '0.85rem',
                    },
                }}
            />

            <Typography variant="caption" color="text.disabled" sx={{ mt: 1, display: 'block' }}>
                Formatos soportados: Feature, FeatureCollection, Polygon, MultiPolygon
            </Typography>
        </Box>
    )
}

export default TextPaster
